var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd',_vm._l((_vm.videoList),function(item,index){return _c('a',{key:index},[_c('h6',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.date_start))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2131c7f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/class/ClassDetailVideoList.vue
// module id = null
// module chunks = 